import { render, staticRenderFns } from "./addLesson.vue?vue&type=template&id=7e10a37d&scoped=true"
import script from "./addLesson.vue?vue&type=script&lang=js"
export * from "./addLesson.vue?vue&type=script&lang=js"
import style0 from "./addLesson.vue?vue&type=style&index=0&id=7e10a37d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e10a37d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e10a37d')) {
      api.createRecord('7e10a37d', component.options)
    } else {
      api.reload('7e10a37d', component.options)
    }
    module.hot.accept("./addLesson.vue?vue&type=template&id=7e10a37d&scoped=true", function () {
      api.rerender('7e10a37d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/addLesson.vue"
export default component.exports